export default "__VITE_ASSET__DRlMe4rv__"